/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DashboardRouteImport } from './routes/_dashboard'
import { Route as DashboardIndexRouteImport } from './routes/_dashboard/index'
import { Route as DashboardBranchBranchIdRouteRouteImport } from './routes/_dashboard/branch/$branchId/route'
import { Route as DashboardBranchBranchIdIndexRouteImport } from './routes/_dashboard/branch/$branchId/index'
import { Route as DashboardBranchBranchIdBookingIndexRouteImport } from './routes/_dashboard/branch/$branchId/booking/index'
import { Route as DashboardBranchBranchIdCreateWizardRouteImport } from './routes/_dashboard/branch/$branchId/create/_wizard'
import { Route as DashboardBranchBranchIdBookingIdRouteImport } from './routes/_dashboard/branch/$branchId/booking/$id'
import { Route as DashboardBranchBranchIdCreateWizardTimeRouteImport } from './routes/_dashboard/branch/$branchId/create/_wizard/time'
import { Route as DashboardBranchBranchIdCreateWizardServiceRouteImport } from './routes/_dashboard/branch/$branchId/create/_wizard/service'
import { Route as DashboardBranchBranchIdCreateWizardPaymentRouteImport } from './routes/_dashboard/branch/$branchId/create/_wizard/payment'
import { Route as DashboardBranchBranchIdCreateWizardModeRouteImport } from './routes/_dashboard/branch/$branchId/create/_wizard/mode'
import { Route as DashboardBranchBranchIdCreateWizardConfirmRouteImport } from './routes/_dashboard/branch/$branchId/create/_wizard/confirm'
import { Route as DashboardBranchBranchIdCreateWizardMasterIndexRouteImport } from './routes/_dashboard/branch/$branchId/create/_wizard/master.index'
import { Route as DashboardBranchBranchIdCreateWizardMasterPairRouteImport } from './routes/_dashboard/branch/$branchId/create/_wizard/master.pair'

const DashboardRoute = DashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardBranchBranchIdRouteRoute =
  DashboardBranchBranchIdRouteRouteImport.update({
    id: '/branch/$branchId',
    path: '/branch/$branchId',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardBranchBranchIdIndexRoute =
  DashboardBranchBranchIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardBranchBranchIdRouteRoute,
  } as any)
const DashboardBranchBranchIdBookingIndexRoute =
  DashboardBranchBranchIdBookingIndexRouteImport.update({
    id: '/booking/',
    path: '/booking/',
    getParentRoute: () => DashboardBranchBranchIdRouteRoute,
  } as any)
const DashboardBranchBranchIdCreateWizardRoute =
  DashboardBranchBranchIdCreateWizardRouteImport.update({
    id: '/create/_wizard',
    path: '/create',
    getParentRoute: () => DashboardBranchBranchIdRouteRoute,
  } as any)
const DashboardBranchBranchIdBookingIdRoute =
  DashboardBranchBranchIdBookingIdRouteImport.update({
    id: '/booking/$id',
    path: '/booking/$id',
    getParentRoute: () => DashboardBranchBranchIdRouteRoute,
  } as any)
const DashboardBranchBranchIdCreateWizardTimeRoute =
  DashboardBranchBranchIdCreateWizardTimeRouteImport.update({
    id: '/time',
    path: '/time',
    getParentRoute: () => DashboardBranchBranchIdCreateWizardRoute,
  } as any)
const DashboardBranchBranchIdCreateWizardServiceRoute =
  DashboardBranchBranchIdCreateWizardServiceRouteImport.update({
    id: '/service',
    path: '/service',
    getParentRoute: () => DashboardBranchBranchIdCreateWizardRoute,
  } as any)
const DashboardBranchBranchIdCreateWizardPaymentRoute =
  DashboardBranchBranchIdCreateWizardPaymentRouteImport.update({
    id: '/payment',
    path: '/payment',
    getParentRoute: () => DashboardBranchBranchIdCreateWizardRoute,
  } as any)
const DashboardBranchBranchIdCreateWizardModeRoute =
  DashboardBranchBranchIdCreateWizardModeRouteImport.update({
    id: '/mode',
    path: '/mode',
    getParentRoute: () => DashboardBranchBranchIdCreateWizardRoute,
  } as any)
const DashboardBranchBranchIdCreateWizardConfirmRoute =
  DashboardBranchBranchIdCreateWizardConfirmRouteImport.update({
    id: '/confirm',
    path: '/confirm',
    getParentRoute: () => DashboardBranchBranchIdCreateWizardRoute,
  } as any)
const DashboardBranchBranchIdCreateWizardMasterIndexRoute =
  DashboardBranchBranchIdCreateWizardMasterIndexRouteImport.update({
    id: '/master/',
    path: '/master/',
    getParentRoute: () => DashboardBranchBranchIdCreateWizardRoute,
  } as any)
const DashboardBranchBranchIdCreateWizardMasterPairRoute =
  DashboardBranchBranchIdCreateWizardMasterPairRouteImport.update({
    id: '/master/pair',
    path: '/master/pair',
    getParentRoute: () => DashboardBranchBranchIdCreateWizardRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof DashboardIndexRoute
  '/branch/$branchId': typeof DashboardBranchBranchIdRouteRouteWithChildren
  '/branch/$branchId/': typeof DashboardBranchBranchIdIndexRoute
  '/branch/$branchId/booking/$id': typeof DashboardBranchBranchIdBookingIdRoute
  '/branch/$branchId/create': typeof DashboardBranchBranchIdCreateWizardRouteWithChildren
  '/branch/$branchId/booking/': typeof DashboardBranchBranchIdBookingIndexRoute
  '/branch/$branchId/create/confirm': typeof DashboardBranchBranchIdCreateWizardConfirmRoute
  '/branch/$branchId/create/mode': typeof DashboardBranchBranchIdCreateWizardModeRoute
  '/branch/$branchId/create/payment': typeof DashboardBranchBranchIdCreateWizardPaymentRoute
  '/branch/$branchId/create/service': typeof DashboardBranchBranchIdCreateWizardServiceRoute
  '/branch/$branchId/create/time': typeof DashboardBranchBranchIdCreateWizardTimeRoute
  '/branch/$branchId/create/master/pair': typeof DashboardBranchBranchIdCreateWizardMasterPairRoute
  '/branch/$branchId/create/master/': typeof DashboardBranchBranchIdCreateWizardMasterIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof DashboardIndexRoute
  '/branch/$branchId': typeof DashboardBranchBranchIdIndexRoute
  '/branch/$branchId/booking/$id': typeof DashboardBranchBranchIdBookingIdRoute
  '/branch/$branchId/create': typeof DashboardBranchBranchIdCreateWizardRouteWithChildren
  '/branch/$branchId/booking': typeof DashboardBranchBranchIdBookingIndexRoute
  '/branch/$branchId/create/confirm': typeof DashboardBranchBranchIdCreateWizardConfirmRoute
  '/branch/$branchId/create/mode': typeof DashboardBranchBranchIdCreateWizardModeRoute
  '/branch/$branchId/create/payment': typeof DashboardBranchBranchIdCreateWizardPaymentRoute
  '/branch/$branchId/create/service': typeof DashboardBranchBranchIdCreateWizardServiceRoute
  '/branch/$branchId/create/time': typeof DashboardBranchBranchIdCreateWizardTimeRoute
  '/branch/$branchId/create/master/pair': typeof DashboardBranchBranchIdCreateWizardMasterPairRoute
  '/branch/$branchId/create/master': typeof DashboardBranchBranchIdCreateWizardMasterIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_dashboard': typeof DashboardRouteWithChildren
  '/_dashboard/': typeof DashboardIndexRoute
  '/_dashboard/branch/$branchId': typeof DashboardBranchBranchIdRouteRouteWithChildren
  '/_dashboard/branch/$branchId/': typeof DashboardBranchBranchIdIndexRoute
  '/_dashboard/branch/$branchId/booking/$id': typeof DashboardBranchBranchIdBookingIdRoute
  '/_dashboard/branch/$branchId/create/_wizard': typeof DashboardBranchBranchIdCreateWizardRouteWithChildren
  '/_dashboard/branch/$branchId/booking/': typeof DashboardBranchBranchIdBookingIndexRoute
  '/_dashboard/branch/$branchId/create/_wizard/confirm': typeof DashboardBranchBranchIdCreateWizardConfirmRoute
  '/_dashboard/branch/$branchId/create/_wizard/mode': typeof DashboardBranchBranchIdCreateWizardModeRoute
  '/_dashboard/branch/$branchId/create/_wizard/payment': typeof DashboardBranchBranchIdCreateWizardPaymentRoute
  '/_dashboard/branch/$branchId/create/_wizard/service': typeof DashboardBranchBranchIdCreateWizardServiceRoute
  '/_dashboard/branch/$branchId/create/_wizard/time': typeof DashboardBranchBranchIdCreateWizardTimeRoute
  '/_dashboard/branch/$branchId/create/_wizard/master/pair': typeof DashboardBranchBranchIdCreateWizardMasterPairRoute
  '/_dashboard/branch/$branchId/create/_wizard/master/': typeof DashboardBranchBranchIdCreateWizardMasterIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/branch/$branchId'
    | '/branch/$branchId/'
    | '/branch/$branchId/booking/$id'
    | '/branch/$branchId/create'
    | '/branch/$branchId/booking/'
    | '/branch/$branchId/create/confirm'
    | '/branch/$branchId/create/mode'
    | '/branch/$branchId/create/payment'
    | '/branch/$branchId/create/service'
    | '/branch/$branchId/create/time'
    | '/branch/$branchId/create/master/pair'
    | '/branch/$branchId/create/master/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/branch/$branchId'
    | '/branch/$branchId/booking/$id'
    | '/branch/$branchId/create'
    | '/branch/$branchId/booking'
    | '/branch/$branchId/create/confirm'
    | '/branch/$branchId/create/mode'
    | '/branch/$branchId/create/payment'
    | '/branch/$branchId/create/service'
    | '/branch/$branchId/create/time'
    | '/branch/$branchId/create/master/pair'
    | '/branch/$branchId/create/master'
  id:
    | '__root__'
    | '/_dashboard'
    | '/_dashboard/'
    | '/_dashboard/branch/$branchId'
    | '/_dashboard/branch/$branchId/'
    | '/_dashboard/branch/$branchId/booking/$id'
    | '/_dashboard/branch/$branchId/create/_wizard'
    | '/_dashboard/branch/$branchId/booking/'
    | '/_dashboard/branch/$branchId/create/_wizard/confirm'
    | '/_dashboard/branch/$branchId/create/_wizard/mode'
    | '/_dashboard/branch/$branchId/create/_wizard/payment'
    | '/_dashboard/branch/$branchId/create/_wizard/service'
    | '/_dashboard/branch/$branchId/create/_wizard/time'
    | '/_dashboard/branch/$branchId/create/_wizard/master/pair'
    | '/_dashboard/branch/$branchId/create/_wizard/master/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  DashboardRoute: typeof DashboardRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/': {
      id: '/_dashboard/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/branch/$branchId': {
      id: '/_dashboard/branch/$branchId'
      path: '/branch/$branchId'
      fullPath: '/branch/$branchId'
      preLoaderRoute: typeof DashboardBranchBranchIdRouteRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/branch/$branchId/': {
      id: '/_dashboard/branch/$branchId/'
      path: '/'
      fullPath: '/branch/$branchId/'
      preLoaderRoute: typeof DashboardBranchBranchIdIndexRouteImport
      parentRoute: typeof DashboardBranchBranchIdRouteRoute
    }
    '/_dashboard/branch/$branchId/booking/': {
      id: '/_dashboard/branch/$branchId/booking/'
      path: '/booking'
      fullPath: '/branch/$branchId/booking/'
      preLoaderRoute: typeof DashboardBranchBranchIdBookingIndexRouteImport
      parentRoute: typeof DashboardBranchBranchIdRouteRoute
    }
    '/_dashboard/branch/$branchId/create/_wizard': {
      id: '/_dashboard/branch/$branchId/create/_wizard'
      path: '/create'
      fullPath: '/branch/$branchId/create'
      preLoaderRoute: typeof DashboardBranchBranchIdCreateWizardRouteImport
      parentRoute: typeof DashboardBranchBranchIdRouteRoute
    }
    '/_dashboard/branch/$branchId/booking/$id': {
      id: '/_dashboard/branch/$branchId/booking/$id'
      path: '/booking/$id'
      fullPath: '/branch/$branchId/booking/$id'
      preLoaderRoute: typeof DashboardBranchBranchIdBookingIdRouteImport
      parentRoute: typeof DashboardBranchBranchIdRouteRoute
    }
    '/_dashboard/branch/$branchId/create/_wizard/time': {
      id: '/_dashboard/branch/$branchId/create/_wizard/time'
      path: '/time'
      fullPath: '/branch/$branchId/create/time'
      preLoaderRoute: typeof DashboardBranchBranchIdCreateWizardTimeRouteImport
      parentRoute: typeof DashboardBranchBranchIdCreateWizardRoute
    }
    '/_dashboard/branch/$branchId/create/_wizard/service': {
      id: '/_dashboard/branch/$branchId/create/_wizard/service'
      path: '/service'
      fullPath: '/branch/$branchId/create/service'
      preLoaderRoute: typeof DashboardBranchBranchIdCreateWizardServiceRouteImport
      parentRoute: typeof DashboardBranchBranchIdCreateWizardRoute
    }
    '/_dashboard/branch/$branchId/create/_wizard/payment': {
      id: '/_dashboard/branch/$branchId/create/_wizard/payment'
      path: '/payment'
      fullPath: '/branch/$branchId/create/payment'
      preLoaderRoute: typeof DashboardBranchBranchIdCreateWizardPaymentRouteImport
      parentRoute: typeof DashboardBranchBranchIdCreateWizardRoute
    }
    '/_dashboard/branch/$branchId/create/_wizard/mode': {
      id: '/_dashboard/branch/$branchId/create/_wizard/mode'
      path: '/mode'
      fullPath: '/branch/$branchId/create/mode'
      preLoaderRoute: typeof DashboardBranchBranchIdCreateWizardModeRouteImport
      parentRoute: typeof DashboardBranchBranchIdCreateWizardRoute
    }
    '/_dashboard/branch/$branchId/create/_wizard/confirm': {
      id: '/_dashboard/branch/$branchId/create/_wizard/confirm'
      path: '/confirm'
      fullPath: '/branch/$branchId/create/confirm'
      preLoaderRoute: typeof DashboardBranchBranchIdCreateWizardConfirmRouteImport
      parentRoute: typeof DashboardBranchBranchIdCreateWizardRoute
    }
    '/_dashboard/branch/$branchId/create/_wizard/master/': {
      id: '/_dashboard/branch/$branchId/create/_wizard/master/'
      path: '/master'
      fullPath: '/branch/$branchId/create/master/'
      preLoaderRoute: typeof DashboardBranchBranchIdCreateWizardMasterIndexRouteImport
      parentRoute: typeof DashboardBranchBranchIdCreateWizardRoute
    }
    '/_dashboard/branch/$branchId/create/_wizard/master/pair': {
      id: '/_dashboard/branch/$branchId/create/_wizard/master/pair'
      path: '/master/pair'
      fullPath: '/branch/$branchId/create/master/pair'
      preLoaderRoute: typeof DashboardBranchBranchIdCreateWizardMasterPairRouteImport
      parentRoute: typeof DashboardBranchBranchIdCreateWizardRoute
    }
  }
}

interface DashboardBranchBranchIdCreateWizardRouteChildren {
  DashboardBranchBranchIdCreateWizardConfirmRoute: typeof DashboardBranchBranchIdCreateWizardConfirmRoute
  DashboardBranchBranchIdCreateWizardModeRoute: typeof DashboardBranchBranchIdCreateWizardModeRoute
  DashboardBranchBranchIdCreateWizardPaymentRoute: typeof DashboardBranchBranchIdCreateWizardPaymentRoute
  DashboardBranchBranchIdCreateWizardServiceRoute: typeof DashboardBranchBranchIdCreateWizardServiceRoute
  DashboardBranchBranchIdCreateWizardTimeRoute: typeof DashboardBranchBranchIdCreateWizardTimeRoute
  DashboardBranchBranchIdCreateWizardMasterPairRoute: typeof DashboardBranchBranchIdCreateWizardMasterPairRoute
  DashboardBranchBranchIdCreateWizardMasterIndexRoute: typeof DashboardBranchBranchIdCreateWizardMasterIndexRoute
}

const DashboardBranchBranchIdCreateWizardRouteChildren: DashboardBranchBranchIdCreateWizardRouteChildren =
  {
    DashboardBranchBranchIdCreateWizardConfirmRoute:
      DashboardBranchBranchIdCreateWizardConfirmRoute,
    DashboardBranchBranchIdCreateWizardModeRoute:
      DashboardBranchBranchIdCreateWizardModeRoute,
    DashboardBranchBranchIdCreateWizardPaymentRoute:
      DashboardBranchBranchIdCreateWizardPaymentRoute,
    DashboardBranchBranchIdCreateWizardServiceRoute:
      DashboardBranchBranchIdCreateWizardServiceRoute,
    DashboardBranchBranchIdCreateWizardTimeRoute:
      DashboardBranchBranchIdCreateWizardTimeRoute,
    DashboardBranchBranchIdCreateWizardMasterPairRoute:
      DashboardBranchBranchIdCreateWizardMasterPairRoute,
    DashboardBranchBranchIdCreateWizardMasterIndexRoute:
      DashboardBranchBranchIdCreateWizardMasterIndexRoute,
  }

const DashboardBranchBranchIdCreateWizardRouteWithChildren =
  DashboardBranchBranchIdCreateWizardRoute._addFileChildren(
    DashboardBranchBranchIdCreateWizardRouteChildren,
  )

interface DashboardBranchBranchIdRouteRouteChildren {
  DashboardBranchBranchIdIndexRoute: typeof DashboardBranchBranchIdIndexRoute
  DashboardBranchBranchIdBookingIdRoute: typeof DashboardBranchBranchIdBookingIdRoute
  DashboardBranchBranchIdCreateWizardRoute: typeof DashboardBranchBranchIdCreateWizardRouteWithChildren
  DashboardBranchBranchIdBookingIndexRoute: typeof DashboardBranchBranchIdBookingIndexRoute
}

const DashboardBranchBranchIdRouteRouteChildren: DashboardBranchBranchIdRouteRouteChildren =
  {
    DashboardBranchBranchIdIndexRoute: DashboardBranchBranchIdIndexRoute,
    DashboardBranchBranchIdBookingIdRoute:
      DashboardBranchBranchIdBookingIdRoute,
    DashboardBranchBranchIdCreateWizardRoute:
      DashboardBranchBranchIdCreateWizardRouteWithChildren,
    DashboardBranchBranchIdBookingIndexRoute:
      DashboardBranchBranchIdBookingIndexRoute,
  }

const DashboardBranchBranchIdRouteRouteWithChildren =
  DashboardBranchBranchIdRouteRoute._addFileChildren(
    DashboardBranchBranchIdRouteRouteChildren,
  )

interface DashboardRouteChildren {
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardBranchBranchIdRouteRoute: typeof DashboardBranchBranchIdRouteRouteWithChildren
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardBranchBranchIdRouteRoute:
    DashboardBranchBranchIdRouteRouteWithChildren,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  DashboardRoute: DashboardRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
